import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LayoutConfigService, SplashScreenService } from './core/_base/layout';
import { TranslationService } from './core/_base/metronic';
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { ApiService } from './api.service';
import { Router, Event, NavigationStart, NavigationEnd, RouteConfigLoadStart, ResolveStart, NavigationError, RoutesRecognized, NavigationCancel } from '@angular/router';
import {
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SubheaderService,
	KtDialogService
} from './core/_base/layout';
@Component({
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'Metronic';
	loader: boolean;
	match: any;
	path = ['/login', '/', '/default', '/default/dashboard'];
	previousUrl: string;
	private unsubscribe: Subscription[] = [];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	role = [];
	constructor(private translationService: TranslationService,
		private router: Router,
		private layoutConfigService: LayoutConfigService,
		private MenuConfigService: MenuConfigService,
		private splashScreenService: SplashScreenService, private cs: ApiService) {
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
	}
	ngOnInit(): void {
		this.loader = this.layoutConfigService.getConfig('loader.enabled');
		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.splashScreenService.hide();
				window.scrollTo(0, 0);
			}

		});
		this.unsubscribe.push(routerSubscription);
	}
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}
